"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chevron_small_up = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var chevron_small_up = function chevron_small_up(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'chevron-small-up-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M14.5303 13.1493C14.2374 13.4422 13.7626 13.4422 13.4697 13.1493L10 9.67968L6.53033 13.1493C6.23744 13.4422 5.76256 13.4422 5.46967 13.1493C5.17678 12.8565 5.17678 12.3816 5.46967 12.0887L9.46967 8.08869C9.61032 7.94804 9.80109 7.86902 10 7.86902C10.1989 7.86902 10.3897 7.94804 10.5303 8.08869L14.5303 12.0887C14.8232 12.3816 14.8232 12.8565 14.5303 13.1493Z',
    fill: '#4B5563'
  }));
};

exports.chevron_small_up = chevron_small_up;